<!--
 * COPYRIGHT Transtron Inc 2022
 *
 * 機能名：機能一覧サブ画面
 *
 * 作成者：2021/11/23 ノア）黄
 * 最終修正者：2022/01/11 ノア）虞
 *
 -->
<template>
  <ttiDialog :isShow="isShow" @handelDisplay="onHandelDisplay" :manualKey="manualKey" :title="$t('menu.screens')">
    <template slot="body">
      <div class="tti-screen-body">
        <div class="box-card" v-for="(el, ind) in screenList" :key="ind">
          <template v-if="checkAllSubMenu(el)">
            <div class="tti-content-title">
              <tti-svg-icon :icon-name="el.icon"></tti-svg-icon>
              {{ el.menuName }}
            </div>
            <div class="tti-screen-menu-body">
              <div v-for="(elChild, indChild) in el.children" :key="indChild">
                <div
                  class="tti-screen-menu-body-item"
                  v-if="userRole === UserRole.SYSTEM || userRole === elChild.role"
                  @click="onMenuClick(elChild.menuId)"
                  v-tooltip="{
                    content: `${getDefinitionName(menuMaster, elChild.menuId, { code: 'code', value: 'tip' })}`,
                    placement: 'bottom-start',
                    delay: { show: 1000, hide: 0 }
                  }"
                >
                  <div class="menu-name">{{ elChild.menuName }}</div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </template>
  </ttiDialog>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

import { dialog } from '@/store/modules'
import config from '@/config/config'
import { getMenuMasterConfig, getMenuConfig } from '@/config'
import TtiDialog from '@/components/TtiDialog.vue'
import manualConfig from '@/config/manualConfig'
import { localService } from '@/commons/services/localService'
import { PageType, UserRole } from '@/commons/constants'
import HelperService from '@/service/helperService'
import { MenuItem } from '@/models'
import { i18n } from '@/locales'

@Component({
  name: 'home-screens',
  components: {
    TtiDialog
  }
})
export default class HOME_SCREENS extends Vue {
  /**
   * ユーザ種類
   *
   * @readonly
   * @constant
   */
  UserRole = UserRole

  /**
   * ユーザ種類
   */
  userRole = localService?.userInfo?.role || ''

  /**
   * メニュー情報
   */
  screenList = getMenuConfig().screenList

  /**
   * 機能一覧汎用定義
   */
  menuMaster = getMenuMasterConfig().menuMaster

  /**
   * 機能一覧サブ画面の表示フラグを取得
   *
   * @returns {boolean} 機能一覧サブ画面の表示フラグ
   */
  get isShow(): boolean {
    this.initMenuList()
    return dialog.isScreenDialogShow
  }

  /**
   * 機能一覧サブ画面の表示フラグを設定する
   *
   * @param {boolean} value 機能一覧サブ画面の表示フラグ
   */
  set isShow(value: boolean) {
    dialog.setScreenDialogShow(value)
  }

  /**
   * メニュー情報初期化
   */
  initMenuList(): void {
    this.screenList = getMenuConfig().screenList
    this.menuMaster = getMenuMasterConfig().menuMaster
    this.judgeMenuShow()
  }

  /**
   * 機能一覧サブ画面の表示フラグを設定する
   *
   */
  judgeMenuShow(): void {
    if (localService.itpConnectValidFlag === '1') {
      this.screenList.forEach((el: MenuItem) => {
        if (el.icon === 'wo_007') {
          el.children.push({
            type: PageType.PAGE,
            menuId: 'connectCompanyMaster',
            menuName: i18n.t('menu.connectCompanyMaster') as string,
            role: UserRole.SYSTEM
          })
        }
      })

      this.menuMaster.push({
        code: 'connectCompanyMaster',
        value: i18n.t('menu.connectCompanyMaster').toString(),
        tip: i18n.t('menu.connectCompanyMasterTip').toString()
      })
    }
  }

  /**
   * 表示状態変更
   *
   * @param {boolean} value 表示状態
   * @returns {void}
   */
  onHandelDisplay(value: boolean): void {
    dialog.setScreenDialogShow(value)
  }

  /**
   * 機能一覧サブ画面のマニュアルキーを取得
   *
   * @returns {string} 機能一覧サブ画面のマニュアルキー
   */
  get manualKey(): string {
    return manualConfig.route.homeScreens
  }

  getDefinitionName = HelperService.getDefinitionName

  /**
   * メニューをクリックした時の処理
   *
   * @param {string} menu クリックしたメニュー
   * @returns {void}
   */
  onMenuClick(menu: string): void {
    this.$router.push(config.menu[menu])
    this.isShow = false
  }

  /**
   * それが属するサブメニューが表示されているかどうかを確認する
   *
   * @param {MenuItem} menuItem 機能
   * @returns {boolean} 表示するかどうか
   */
  checkAllSubMenu(menuItem: MenuItem): boolean {
    if (!menuItem || !menuItem.children) return false

    let isShow = false
    for (const item of menuItem.children) {
      if (this.userRole === UserRole.SYSTEM || this.userRole === item.role) {
        isShow = true
        break
      }
    }

    return isShow
  }
}
</script>

<style scoped lang="scss">
.tti-screen-body {
  display: flex;
  flex-wrap: wrap;
}

.tti-screen-body .box-card {
  flex: auto;
  margin: 10px;
}

.tti-content-title {
  font-size: $FS01;
  color: $C08;

  .svg-icon {
    padding-right: 6px;
  }
}

.tti-screen-menu-body {
  height: calc(100% - 40px);
  background-color: $C01;
}

.tti-screen-menu-body-item {
  padding: 5px 10px;
  color: $C08;
}
</style>
